"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    className: "fill-primary"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.4,8.2h-1.2v3.7h0.9c0.6,0,1.3-0.1,1.8-0.5l0,0c0.4-0.3,0.6-0.9,0.6-1.4c0-0.5-0.1-1-0.5-1.3 C13.5,8.3,13,8.1,12.4,8.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.2,0H0.8C0.4,0,0,0.4,0,0.8v22.3C0,23.6,0.4,24,0.8,24h22.3c0.5,0,0.8-0.4,0.8-0.8V0.8 C24,0.4,23.6,0,23.2,0z M15.8,12.9c-1,0.7-2.3,1.1-3.5,1h-1.1v4.3H8.6V6.1h3.9c1.2-0.1,2.4,0.3,3.4,1c0.8,0.7,1.2,1.7,1.1,2.8 C17,11.1,16.6,12.1,15.8,12.9z"
  })));
};

exports["default"] = _default;